import z from "zod";

import { IconBaseSchema } from "@shared/content-types/schemas/common.schema";
import { StrapiMediaSchema } from "@shared/content-types/schemas/media.schema";

export const CardInfoSchema = z.object({
  title: z.string().min(1),
  mainColor: z.string().min(1),
  id: z.number().positive(),
  link: z.string().min(1),
  icon: IconBaseSchema,
  image: StrapiMediaSchema,
});

export const AboutMoreSchema = z.object({
  isVisible: z.boolean().optional().default(true),
  title: z.string().min(1),
  description: z.string().min(1),
  cards: z.array(CardInfoSchema),
});
